
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"33","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.107 3.256l15.38 26.49M29.47 8.383L2.98 24.62M8.961 29.746l14.527-26.49M2.98 9.238l26.49 15.38M.416 16.928h30.762M15.797.692l.427 31.617","stroke":"#000"}}),_c('circle',{attrs:{"cx":"15.797","cy":"16.928","r":"7.191","fill":"#fff","stroke":"#000"}})])
          )
        }
      }
    